module.exports = __webpack_public_path__ + "static/img/__8366.5ca4989.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8366.jpg
// module id = 5gXr
// module chunks = 0